import { render, staticRenderFns } from "./mainDetail.vue?vue&type=template&id=a001f0fe&scoped=true&"
import script from "./mainDetail.vue?vue&type=script&lang=js&"
export * from "./mainDetail.vue?vue&type=script&lang=js&"
import style0 from "./mainDetail.vue?vue&type=style&index=0&id=a001f0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a001f0fe",
  null
  
)

export default component.exports